import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { updateFacilitiesAction } from "../../actions/choiceLists";
import { getAvailableFeaturesAction } from "../../actions/features";
import { getUserPreferencesAction } from "../../actions/getUserPreferences";
import { initializeAction } from "../../actions/initialize";

import { Initializing } from "./Initializing";

import type { State } from "../../reducers";

const mapStateToProps = (state: State) => ({
  lookups: state.lookups,
  ui: state.ui,
});

const mapDispatchToProps = (dispatch) => ({
  initialize: () => dispatch(initializeAction()),
  getAvailableFeatures: () => dispatch(getAvailableFeaturesAction()),
  // TODO: this looks unused
  updateFacilities: () => dispatch(updateFacilitiesAction()),
  getUserPreferences: () => dispatch(getUserPreferencesAction()),
});

export const InitializingContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(Initializing));
